"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropDown = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
class DropDown extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      selectedValue: props.selectedValue
    };
    this.toggle = this.toggle.bind(this);
    this.changeValue = this.changeValue.bind(this);
  }
  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.setState({
        selectedValue: this.props.selectedValue
      });
    }
  }
  changeValue(e) {
    this.setState({
      selectedValue: e.currentTarget.textContent
    });
  }
  render() {
    const {
      dropdownOpen,
      selectedValue = ''
    } = this.state;
    const {
      changeValue,
      className,
      dropDownItems,
      showCaret
    } = this.props;
    const style = {
      color: '#b5babe',
      width: "1rem",
      height: "1rem",
      float: 'right'
    };
    const obj = this.props.changeValue ? changeValue : this.changeValue;
    return /*#__PURE__*/_react.default.createElement(_reactstrap.Dropdown, {
      isOpen: dropdownOpen,
      toggle: this.toggle,
      className: (0, _classnames.default)("ixn-dropdown ".concat(className))
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownToggle, {
      className: "ixn-dropdown__dropdown-component"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ixn-dropdown__dropdown-value"
    }, selectedValue), showCaret && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ['fas', 'chevron-down'],
      style: style
    })), /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownMenu, {
      className: "ixn-dropdown__dropdown-list"
    }, dropDownItems.map((item, index) => /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownItem, {
      key: "".concat(item).concat(index),
      onClick: event => {
        obj(event);
      }
    }, item))));
  }
}
exports.DropDown = DropDown;
DropDown.defaultProps = {
  className: '',
  dropDownItems: [],
  showCaret: true
};
DropDown.propTypes = {
  /** Contain various classes which apply styling to dropdown */
  className: _propTypes.default.string,
  /** Array to contain dropdown list */
  dropDownItems: _propTypes.default.array,
  /** Specifies boolean value to show caret or not */
  showCaret: _propTypes.default.bool
};